<div *ngIf="modelProperty !== null" class="flex justify-center w-full">
  <div class="flex flex-col justify-center sm:border-b border-gray-400">
    <div class="pb-2">
      <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
    </div>
    <div class="flex justify-between items-end">
      <div *ngIf="!modelProperty.IsMF">
        <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
      </div>
      <div *ngIf="!modelProperty.IsMF" class="justify-items-end">
        <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
            class="font-boldr">{{modelProperty.baths}}</span> ba | <span class="font-bold">{{modelProperty.sqft}}</span>
          sqft</p>
      </div>
    </div>
    <div class="sm:pb-8">
      <div>{{modelProperty.title}}</div>
    </div>
  </div>
</div>